export class Dataset {
  id: number;
  name: string;
  description: string;
  file: string;
  backfill_days: number;
}